import { Skeleton } from "@/components/ui/skeleton";

/**
 * Generic page-level skeleton used as a `pendingComponent` for routes.
 * Matches the visual rhythm of the app: thin tag, headline, divider, card grid.
 */
export function RouteSkeleton({ cards = 4 }: { cards?: number }) {
  return (
    <div className="min-h-screen bg-background">
      <div className="border-b border-border h-16" />
      <main className="mx-auto max-w-7xl px-6 py-10">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="mt-4 h-8 w-72" />
        <Skeleton className="mt-4 h-px w-16" />

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: cards }).map((_, i) => (
            <div key={i} className="border border-border bg-card p-6">
              <Skeleton className="h-5 w-3/4" />
              <Skeleton className="mt-3 h-3 w-1/2" />
              <Skeleton className="mt-6 h-3 w-full" />
              <Skeleton className="mt-2 h-3 w-5/6" />
              <Skeleton className="mt-2 h-3 w-4/6" />
              <div className="mt-6 flex gap-3">
                <Skeleton className="h-8 w-20" />
                <Skeleton className="h-8 w-20" />
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export function ListRouteSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <div className="min-h-screen bg-background">
      <div className="border-b border-border h-16" />
      <main className="mx-auto max-w-7xl px-6 py-10">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="mt-4 h-8 w-72" />
        <Skeleton className="mt-4 h-px w-16" />

        <div className="mt-10 space-y-4">
          {Array.from({ length: rows }).map((_, i) => (
            <div key={i} className="border border-border bg-card p-6">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <Skeleton className="h-5 w-1/2" />
                  <Skeleton className="mt-2 h-3 w-1/3" />
                  <Skeleton className="mt-3 h-3 w-2/3" />
                </div>
                <Skeleton className="h-8 w-24" />
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
